import { combineReducers } from "redux";
import UserReducer from "../reducers/user-reducer";
import UtilityReducer from "../reducers/utility-reducer";
import usersReducer from "../reducers/users-reducers";
import ProductCategoryReducer from "../reducers/product-category";
import ProductReducer from "../reducers/product/product";
import LocationReducer from "../reducers/location/location";
import InventoryReducer from "../reducers/inventory/inventory";
import CartReducer from "../reducers/cart-reducer/cart.reducer";
import SalesReducer from "../reducers/sales/index";
import PickUpStationReducer from "../reducers/pick-up-station/pick-up-station";
import OrderDeliveryReducer from "../reducers/order-delivery/order-delivery";
import AccountReducer from "../reducers/accounts/account";
import PersistReducer from "../reducers/persist/persist-reducer";
import PaymentHistoryReducer from "../reducers/payment-history/payment-history";
import StorageTanksReducer from "../reducers/storage-tanks/storage-tanks";
import ProductSalesPriceReducer from "../reducers/product-sales-price/product-sales-price";
import LogisticsCostReducer from "../reducers/logistics-cost/logistics-cost";
import SupplierReducer from "../reducers/supplier/supplier";

const rootReducer = combineReducers({
  userReducer: UserReducer,
  utilityReducer: UtilityReducer,
  usersReducer: usersReducer,
  productCategoryReducer: ProductCategoryReducer,
  productReducer: ProductReducer,
  productSalesPriceReducer: ProductSalesPriceReducer,
  logisticsCostReducer: LogisticsCostReducer,
  supplierReducer: SupplierReducer,
  locationReducer: LocationReducer,
  storageTanksReducer: StorageTanksReducer,
  inventoryReducer: InventoryReducer,
  cartReducer: CartReducer,
  persistReducer: PersistReducer,
  salesReducer: SalesReducer,
  pickUpStationReducer: PickUpStationReducer,
  orderDeliveryReducer: OrderDeliveryReducer,
  accountReducer: AccountReducer,
  paymentHistory: PaymentHistoryReducer,
});

export default rootReducer;
